import { customEvent } from "goi_common";

interface NearbyParlor {
  id: number;
  companyname: string;
  sido: string;
}

interface ParlorNearbyProps {
  companyName: string;
  hospitalLink?: string;
  sidoName: string;
  sigunguName: string;
  parlorId: string;
  nearbyParlors: NearbyParlor[];
}

export const ParlorNearby = ({
  companyName,
  hospitalLink,
  sidoName,
  sigunguName,
  parlorId,
  nearbyParlors,
}: ParlorNearbyProps) => {
  return (
    <section
      className="pd-section"
      id="pd-nearby"
      aria-labelledby="pd-nearby-title"
    >
      <header className="pd-section__head">
        <div className="pd-section__title-block">
          <span className="pd-section__eyebrow">연계 시설 · 인근 장례식장</span>
          <h2 id="pd-nearby-title">가까운 병원과 인근 장례식장</h2>
          <p className="pd-section__desc">
            {companyName}과 가까운 의료 시설과 인근 지역 장례식장 정보입니다.
          </p>
        </div>
      </header>

      <div className="pd-link-row">
        {hospitalLink && (
          <a
            className="pd-link-card"
            href={hospitalLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="pd-link-card__eyebrow">연계 병원</span>
            <span className="pd-link-card__title">인근 병원 안내</span>
            <span className="pd-link-card__meta">
              {sigunguName} · 병원 정보
            </span>
          </a>
        )}
        <a
          className="pd-link-card pd-link-card--accent"
          href={`${process.env.NEXT_PUBLIC_PLATFORM_WEB_URL}/match/parlor-requests/${parlorId}/?utm_campaign=parlor`}
          onClick={() =>
            customEvent({
              newGtm: {
                path: "prlr_fam_main",
                trigger_and_target: "uv-mtch_rqst_prlr",
              },
            })
          }
        >
          <span className="pd-link-card__eyebrow">한눈에 비교</span>
          <span className="pd-link-card__title">장례 견적 비교</span>
          <span className="pd-link-card__meta">
            시설 · 비용 · 위치 동시 비교
          </span>
        </a>
        <a
          className="pd-link-card"
          href={`${process.env.NEXT_PUBLIC_PLATFORM_WEB_URL}/parlors/region/${sidoName}-${sigunguName}/`}
        >
          <span className="pd-link-card__eyebrow">지역 둘러보기</span>
          <span className="pd-link-card__title">{sidoName} 장례식장</span>
          <span className="pd-link-card__meta">
            {sidoName} 전체 장례식장 보기
          </span>
        </a>
      </div>

      {nearbyParlors.length > 0 && (
        <div className="pd-nearby-list" aria-label="인근 장례식장 목록">
          {nearbyParlors.map((p) => (
            <a
              key={p.id}
              className="pd-nearby-item"
              href={`/place/${p.id}/family/main/`}
            >
              <span className="pd-nearby-item__name">{p.companyname}</span>
              <span className="pd-nearby-item__region">{sidoName}</span>
            </a>
          ))}
        </div>
      )}
    </section>
  );
};
